import { Params } from '../../core/adaptor';
import { getTooltipMapping } from '../../utils/tooltip';
import { deepAssign } from '../../utils';
import { geometry, MappingOptions, GeometryOptions } from './base';

export interface SchemaGeometryOptions extends GeometryOptions {
  /** x è½´å­æ®µ */
  readonly xField?: string;
  /** y è½´å­æ®µ */
  readonly yField?: string;
  /** åç»å­æ®µ */
  readonly seriesField?: string;
  /** point å¾å½¢æ å°è§å */
  readonly schema?: MappingOptions;
}

/**
 * schema çéç½®å¤ç
 * @param params
 */
export function schema<O extends SchemaGeometryOptions>(params: Params<O>): Params<O> {
  const { options } = params;
  const { schema, xField, yField, seriesField, tooltip } = options;

  const { fields, formatter } = getTooltipMapping(tooltip, [xField, yField, seriesField]);

  return schema
    ? geometry(
        deepAssign({}, params, {
          options: {
            type: 'schema',
            colorField: seriesField,
            tooltipFields: fields,
            mapping: {
              tooltip: formatter,
              ...schema,
            },
          },
        })
      )
    : params;
}
